export default __webpack_public_path__ + "static/media/finance.bc36a450.svg";